import React, { useEffect } from 'react';
import ReactGa from 'react-ga';
import '../sources/styles/stylesFooter.css';
import { Container, Row, Col, Figure } from 'react-bootstrap';
import { Facebook, Instagram, Youtube } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom'

function Footer() {
    let imagenPSE = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/LOGO_PSE.png'
    const manual = process.env.REACT_APP_SERVER_IMAGE + 'documentos/';
    const urlPqr = process.env.REACT_APP_PQR_URL || 'https://docs.google.com/forms/d/e/1FAIpQLScv1TQOzxXiHTGoRWEjmKSTIdxCEG7xvE4HYQXg9fJmbsxabQ/viewform';
    const urlTrabajeConNosotros = process.env.REACT_APP_URL_TRABAJE_CON_NOSOTROS || 'https://bancotalento.soferco.tech/';

    useEffect(() => {
        ReactGa.initialize('UA-235989534-1')
        ReactGa.pageview(window.location.pathname + window.location.search)
        // eslint-disable-next-line
    }, []);

    return (
        <Container fluid className="mb-4 containerFooter" style={{ backgroundColor: '#f4f4f4' }}>
            <br />
            <Container>
                <Row >
                    <Col md={4} sm={4}>
                        <h4><em><b>INFORMACIÓN</b></em></h4>
                        <br></br>
                        <ul>
                            {/* <li>
                                <p>Preguntas Frecuentes</p>
                            </li> */}
                            <li>
                                <Link to='/terminosCondiciones' className="enlaceFooter" state={{ page: '/' }}>Términos y condiciones</Link>
                            </li>
                            <li>
                                <Link target={'new'} to='/devoluciones' className="enlaceFooter" state={{ page: '/' }}>Política de devolución</Link>
                            </li>
                            <li>
                                <a target={'new'} href={manual + 'PL-SIG-011 V001 POLITICA PARA EL PROGRAMA DE TRANSPARENCIA Y ETICA EMPRESARIAL.pdf'} className="enlaceFooter">Política de transparencia y ética empresarial</a>
                            </li>
                            <li>
                                <a target={'new'} href={manual + 'PL-SIG-010 V001 POLITICA DE SAGRILAFT - FPADM.pdf'} className="enlaceFooter">Política de SAGRILAFT / FPADM</a>
                            </li>
                            <li>
                                <a target={'new'} href={manual + 'PL-SIG-012 V001 POLITICA DE PROTECCION DE DATOS.pdf'} className="enlaceFooter">Protección de datos</a>
                            </li>
                            <li>
                                <a target={'new'} href={manual + 'FM-SIG-001 AUTORIZACION PARA EL TRATAMIENTO DE DATOS PERSONALES V.003 .pdf'} className="enlaceFooter">Autorización para el tratamiento de datos</a>
                            </li>
                            <li>
                                <a target={'new'} href={urlTrabajeConNosotros} className="enlaceFooter">Trabaje con nosotros</a>
                            </li>
                            <li>
                                <a target={'new'} href={'https://certificadoscont.soferco.tech/index.php'} className="enlaceFooter">Consulta Proveedores</a>
                            </li>
                            <li>
                                <a target={'new'} href={'http://192.168.10.7/calidad/CONSULTA/Pagina%20Calidad/Index.php'} className="enlaceFooter">Sistema Integrado de Gestión</a>
                            </li>
                            <li>
                                <Link to='/contactenos' className="enlaceFooter">Contáctanos</Link>
                            </li>
                            <li>
                                <Link to='/preguntasFrecuentes' className="enlaceFooter" state={{ page: '/' }}>Preguntas Frecuentes</Link>
                            </li>
                        </ul>
                        <br></br>
                    </Col>
                    <Col md={4} sm={4} className='colZonaPago'>
                        <h4><a className="enlaceFooter" target={'new'} href={'https://micrositios.avalpaycenter.com/ferreteria-master-ma'}><em><b>Zona de Pago</b></em></a></h4>

                        {/* Logo PSE */}
                        <a target={'new'} href={'https://micrositios.avalpaycenter.com/ferreteria-master-ma'} className='linkPse'>
                            <Figure.Image
                                className='imagenPse'
                                alt="pse"
                                src={imagenPSE}
                                loading='lazy'
                            />
                        </a>

                        {/* Botón SQR */}
                        <a target={'new'} href={urlPqr} className='btnSqr' rel='noreferrer'>
                            <span className='btnSqrIconWrap' aria-hidden='true'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffb31c" width="28" height="28">
                                    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
                                </svg>
                            </span>
                            <span className='btnSqrTexto'>
                                <span className='btnSqrTitulo'>Sugerencias, quejas<br />y reclamos (SQR)</span>
                                <span className='btnSqrSubtitulo'>Queremos escucharte</span>
                            </span>
                        </a>

                        {/* Texto opinión */}
                        <p className='textoOpinion'>
                            <span className='flechaCurva' aria-hidden='true'>↩</span>
                            ¡Tu opinión<br />nos ayuda a mejorar!
                        </p>

                        {/* Redes sociales */}
                        <div className='redesSociales'>
                            <a target={'new'} href={'https://www.facebook.com/FerreteriaMaster1'} className='iconoRedSocial' aria-label='Facebook' rel='noreferrer'>
                                <Facebook />
                            </a>
                            <a target={'new'} href={'https://www.instagram.com/ferreteria.master/?hl=es'} className='iconoRedSocial' aria-label='Instagram' rel='noreferrer'>
                                <Instagram />
                            </a>
                            <a target={'new'} href={'https://youtube.com/channel/UCftQT5UaH5nuDfYlyCnKm3Q'} className='iconoRedSocial' aria-label='YouTube' rel='noreferrer'>
                                <Youtube />
                            </a>
                        </div>
                    </Col>
                    <Col md={4} sm={4} style={{ textAlign: 'center' }}>
                        <h4><em><b>FERREMASTER</b></em></h4>
                        <br></br>
                        <ul>
                            <li>
                                BUGA<br />
                                Direccion: Cll 7 # 10-50 Centro<br />
                                Telefono: 236 3000<br />
                                Celular: +57 315 592 89 48<br />
                            </li>
                            <li>
                                PALMIRA<br />
                                Direccion: Cra 33A # 28-24<br />
                                Telefono: 266 0066<br />
                                Celular: +57 318 372 70 47<br />

                            </li>
                            <li>
                                TULUA<br />
                                Direccion: Cra 40 # 33-21<br />
                                Telefono: 2339733<br />
                                Celular: +57 317 638 12 10<br />
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
            <br />
            <Row className='rowCopyright'>
                <Col sm={12}>
                    <small>Copyright 2026 © Ferremaster - Todos los derechos reservados</small>
                </Col>
            </Row>
        </Container>
    );
}

export { Footer };

